import { type Country } from '@libs/core';

type GetSddData = {
    country: string;
    storeId: string;
    city: string;
    stateProvince: string;
    addressLine1: string;
    addressLine2?: string;
    postalCode: string;
};

export const getSddData = ({
    country,
    storeId,
    city,
    stateProvince,
    addressLine1,
    addressLine2,
    postalCode,
}: GetSddData) => {
    return {
        storeId,
        dropOffAddress: {
            country: country as Country, // Hack because of Country Enum
            city,
            stateProvince,
            addressLine1,
            addressLine2,
            postalCode,
        },
    };
};
